import { useEffect, useState } from "react"

// Only flips true if `isLoading` is still true after `delay` ms — avoids a
// preloader flash when the track is already cached and loads almost instantly.
export default function useDelayedLoading(isLoading, delay = 150) {
  const [showLoader, setShowLoader] = useState(false)

  useEffect(() => {
    if (!isLoading) {
      setShowLoader(false)
      return undefined
    }

    const timer = setTimeout(() => setShowLoader(true), delay)
    return () => clearTimeout(timer)
  }, [isLoading, delay])

  return showLoader
}
